import { useState, useEffect } from "react";
import { WifiOff } from "lucide-react";
import { useTranslation } from "../i18n";

const NetworkStatus = () => {
    const { t } = useTranslation();
    const [isOnline, setIsOnline] = useState(navigator.onLine);

    useEffect(() => {
        const goOnline = () => setIsOnline(true);
        const goOffline = () => setIsOnline(false);
        window.addEventListener("online", goOnline);
        window.addEventListener("offline", goOffline);
        return () => {
            window.removeEventListener("online", goOnline);
            window.removeEventListener("offline", goOffline);
        };
    }, []);

    if (isOnline) return null;

    return (
        <div className="network-offline-banner">
            <WifiOff size={16} />
            {t("network_offline")}
        </div>
    );
};

export default NetworkStatus;
